import React from 'react'
import { Trash2 } from 'lucide-react'
import { Button, Modal } from '@/components'
import { useLanguage } from '@/contexts/LanguageContext'
import type { useTurbineManagementViewModel } from '../useTurbineManagementViewModel'

type VM = ReturnType<typeof useTurbineManagementViewModel>

interface DeleteTurbineModalProps {
  showDeleteModal: VM['showDeleteModal']
  /** Tek kapanis yolu: backdrop / ESC / Iptal hepsi buraya duser. */
  onClose: VM['closeDeleteModal']
  deletingTurbine: VM['deletingTurbine']
  confirmDeleteTurbine: VM['confirmDeleteTurbine']
  isSubmitting: VM['isDeletingTurbine']
  error: VM['deleteError']
  onDismissError: VM['dismissDeleteError']
}

const DeleteTurbineModal: React.FC<DeleteTurbineModalProps> = ({
  showDeleteModal,
  onClose,
  deletingTurbine,
  confirmDeleteTurbine,
  isSubmitting,
  error,
  onDismissError,
}) => {
  const { t } = useLanguage()

  return (
    <Modal
      isOpen={showDeleteModal && !!deletingTurbine}
      onClose={onClose}
      size="sm"
      // Silme basarisiz olursa modal KAPANMAZ, hata burada durur:
      // kullanici neyin neden silinmedigini gorur ve tekrar deneyebilir.
      error={error}
      onDismissError={onDismissError}
      isSubmitting={isSubmitting}
      footer={
        <div className="flex space-x-3">
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1"
            disabled={isSubmitting}
          >
            {t.dashboard.cancel}
          </Button>
          <Button
            onClick={confirmDeleteTurbine}
            className="flex-1 bg-red-600 hover:bg-red-700"
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {t.dashboard.confirmDelete}
          </Button>
        </div>
      }
    >
      <div className="flex items-center mb-4">
        <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
          <Trash2 className="w-5 h-5 text-red-600" />
        </div>
        <div className="ml-4">
          <h3 className="text-lg font-semibold text-gray-900">{t.dashboard.deleteTurbine}</h3>
        </div>
      </div>

      <div className="text-gray-600">
        <p>
          {deletingTurbine
            ? t.dashboard.confirmDeleteMessage.replace('{turbine}', `${deletingTurbine.city} ${deletingTurbine.code}`)
            : ''}
        </p>
        <p className="mt-4 text-red-600 font-medium">{t.dashboard.confirmAction}</p>
        <div className="ml-4 mt-4 space-y-1">
          <div>• {t.dashboard.deleteWarning1}</div>
          <div>• {t.dashboard.deleteWarning2}</div>
          <div>• {t.dashboard.deleteWarning3}</div>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteTurbineModal
